export default __webpack_public_path__ + "static/media/Kiricocho.d07abf2f.jpg";